import { ScenariosCondition } from '@api';
import { deepEqual } from '@helpers';

export interface UseScenarioStateProps {
  conditions: ScenariosCondition[];
  lastConditions?: ScenariosCondition[];
  entityTags: string[];
  lastEntitiesTags?: string[];
}

export const useScenarioState = ({
  conditions,
  lastConditions,
  entityTags,
  lastEntitiesTags,
}: UseScenarioStateProps) => {
  const hasConditions = !!conditions.length;
  const hasLastConditions = !!lastConditions?.length;
  const showResetAllButton = hasConditions && hasLastConditions;

  const entitiesAreDifferent = !deepEqual(entityTags, lastEntitiesTags);
  const conditionsAreDifferent = !deepEqual(conditions, lastConditions);
  const entitiesOrConditionsChanged =
    entitiesAreDifferent || conditionsAreDifferent;

  const showRunScenarioButton = hasLastConditions
    ? conditionsAreDifferent || entitiesAreDifferent
    : hasConditions && conditionsAreDifferent;

  return {
    showRunScenarioButton,
    showResetAllButton,
    entitiesOrConditionsChanged,
  };
};
